import React from "react";
import usePageTracking from "../hooks/usePageTracking";

const PageTrackingWrapper: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  usePageTracking();
  return <>{children}</>;
};

export default PageTrackingWrapper;
